import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  sendEmailContainer: {
    padding: theme.spacing(3),
    backgroundColor: '#fff',
    borderRadius: theme.spacing(1),
    border: `2px solid #e00001`,
    marginBottom: 0,
    width: '210px',
  },
  sendEmailTitle: {
    padding: theme.spacing(1),
    border: `2px solid #e00001`,
    marginBottom: theme.spacing(1),
    fontSize: theme.spacing(2),
    fontWeight: 700,
    backgroundColor: '#e00001',
    color: '#fff',
  },
  titleSpan: {
    display: 'flex',
    justifyContent: 'center',
    gap: 5,
  },
  customSelect: {
    padding: 10,
    cursor: 'pointer',
    fontSize: 16,
    width: 'auto',
    borderWidth: 1,
    color: 'grey',
    marginBottom: 12,
    marginTop: 20,
  },
  fieldTitle: {
    fontSize: 16,
    fontWeight: 500,
    color: '#000',
  },
  whiteBackground: {
    backgroundColor: 'white',
  },
  errorText: {
    color: 'red',
  },
}));

export default useStyles;
